import React, { useEffect } from 'react';
import { Img, Text, Title } from 'components';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { selectNoticias } from 'store/auth';
import { Col, Divider, Row } from 'antd';

const New = () => {
  const navigate = useNavigate();
  const { noticia: _noticia } = useParams();
  const noticias = useSelector(selectNoticias);
  const noticia = noticias.results.find((n) => n.key === _noticia);

  useEffect(() => {
    if (!noticia) {
      navigate('/noticias');
    }
  }, [noticia]);

  if (!noticia) return null;

  const mod = noticia.imagenes_de_noticias.length % 3;

  const mdByMod = { 2: 12, 1: 24, 0: 8 }[mod];
  const [contenido, contenidoPostImagenes = ''] = noticia.contenido.split('{{divider}}');

  const clean = (val) => val.replace(/\\[a-z]/, '').replace(/\\/, '').trim();
  const renderContenido = (content = '') => content.split('\n').filter((t) => clean(t) || t.includes('\\n'))
    .map((t) => (clean(t) ? <Text style={{ textAlign: 'justify' }} key={t}>{clean(t)}</Text> : <br />));

  return (
    <Row style={{ padding: 5 }}>
      <Title level={2} $uppercase>
        {noticia.titulo}
      </Title>
      <Row gutter={10} style={{ paddingTop: 10, paddingBottom: 10 }}>
        <Col>
          <Text>
            {'Fecha de publicación: '}
            {noticia.fecha_publicacion}
          </Text>
        </Col>
        <Divider style={{ borderLeftWidth: 2, height: 18, top: 5 }} type="vertical" />
        <Col>
          <Text>
            {'Autor: '}
            {noticia.autor}
          </Text>
        </Col>
        <Divider style={{ borderLeftWidth: 2, height: 18, top: 5 }} type="vertical" />
        <Col>
          <Text>
            {'Categoría: '}
            {noticia.tipo_noticia}
          </Text>
        </Col>
        {noticia.dependencia && (
          <>
            <Divider style={{ borderLeftWidth: 2, height: 18, top: 5 }} type="vertical" />
            <Col>
              <Text>
                {'Dependencia: '}
                {noticia.dependencia}
              </Text>
            </Col>
          </>
        )}
      </Row>
      {noticia.imagen && (
        <Img
          src={noticia.imagen}
          style={{ marginBottom: 30, height: '35vh', width: '100%' }}
          alt=""
        />
      )}
      {renderContenido(contenido)}
      {!!noticia.imagenes_de_noticias.length && (
        <Row gutter={[10, 10]} style={{ marginTop: 15, marginBottom: 15 }}>
          {noticia.imagenes_de_noticias.map((imagen, idx) => (
            <Col
              key={imagen.id}
              xs={24}
              sm={24}
              md={mod && noticia.imagenes_de_noticias.length - mod > idx ? 8 : mdByMod}
            >
              <Img style={{ width: '100%' }} src={imagen.archivo} alt="" />
            </Col>
          ))}
        </Row>
      )}
      {renderContenido(contenidoPostImagenes)}
      {noticia.video_url && (
        <Row justify="center" style={{ width: '100%' }}>
          <Col xs={24} sm={24} md={18} style={{ height: '40vh', margin: '30px 0' }}>
            <iframe
              width="100%"
              height="100%"
              src={noticia.video_url}
              title="video"
              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </Col>
        </Row>
      )}
      {noticia.enlace && (
        <a href={noticia.enlace} target="_blank" rel="noreferrer" style={{ marginTop: 20 }}>
          <Text $accent strong>
            <Text style={{ color: 'inherit', textAlign: 'start' }}>
              {`Enlace: ${noticia.enlace}`}
            </Text>
          </Text>
        </a>
      )}
    </Row>
  );
};

export default New;
